import React, { useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useAuth } from "../../../context/contextAuth";
import { useDesign } from "../../../context/contextDesign";
import { useProfile } from "../../../context/contextProfile";
import { useThemeMode } from "../../../context/contextTheme";
import { useNav } from "../../../context/contextNav";

const HWVal = 40;

const ProfileDropdown = () => {
  const { theme } = useThemeMode();
  const { user, getSignout } = useAuth();
  const { profilePicUrl, loadProfilePicture } = useProfile();
  const { toggleProfileCard } = useDesign();
  const { setActiveNav } = useNav();

  const handleSignout = async () => {
    await getSignout();
    setActiveNav(0);
  };

  useEffect(() => {
    loadProfilePicture();
  }, []);

  return (
    <Dropdown align="end" className="px-2">
      {/* TOGGLE */}
      <Dropdown.Toggle
        as="button"
        className="bg-transparent border-0 p-0 d-flex align-items-center gap-1"
        style={{ outline: "none" }}
      >
        {/* Profile Image */}
        <img
          src={profilePicUrl}
          alt="Profile"
          width={HWVal}
          height={HWVal}
          className="rounded-circle"
          style={{
            border: `2px solid ${theme.textColor}`,
            objectFit: "cover",
          }}
        />

        {/* Small Caret */}
        <i
          className="bi bi-caret-down-fill"
          style={{
            fontSize: 12,
            color: theme.textColor,
            marginTop: 2,
          }}
        />
      </Dropdown.Toggle>

      {/* MENU */}
      <Dropdown.Menu
        className="shadow rounded-4 mt-2"
        style={{
          width: 200,
          border: `1px solid ${theme.border}`,
          fontSize: 14,
        }}
      >
        {/* USER INFO */}
        <Dropdown.ItemText className="py-2">
          <div className="fw-semibold" style={{ fontSize: 16 }}>
            {`${user?.first_name} ${user?.last_name}`}
          </div>
          <div style={{ fontSize: 11 }}>@{user?.username}</div>
        </Dropdown.ItemText>

        <Dropdown.Divider />

        {/* SETTINGS */}
        <Dropdown.Item onClick={toggleProfileCard}>
          <i className="bi bi-gear me-2"></i>
          Settings
        </Dropdown.Item>

        <Dropdown.Divider />

        {/* SIGN OUT */}
        <Dropdown.Item
          onClick={handleSignout}
          className="text-danger"
        >
          <i className="bi bi-box-arrow-right me-2"></i>
          Sign Out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
